import { render, staticRenderFns } from "./SpouseParent.vue?vue&type=template&id=2ffebaff&scoped=true&"
import script from "./SpouseParent.vue?vue&type=script&lang=js&"
export * from "./SpouseParent.vue?vue&type=script&lang=js&"
import style0 from "./SpouseParent.vue?vue&type=style&index=0&id=2ffebaff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffebaff",
  null
  
)

export default component.exports